export default (function () {
  const forms = document.querySelectorAll('form');
  forms.forEach(function(form) {
    form.addEventListener('submit', function (e) {
      const elm = document.activeElement;
      if (elm.hasAttribute('noduplicate')) {
        elm.disabled = true;
        document.body.style.cursor = 'wait';
      }
    });
  });
})();
